import { render, staticRenderFns } from "./BrowsTemplatesFilters.vue?vue&type=template&id=370f3d32&scoped=true&"
import script from "./BrowsTemplatesFilters.vue?vue&type=script&lang=js&"
export * from "./BrowsTemplatesFilters.vue?vue&type=script&lang=js&"
import style0 from "./BrowsTemplatesFilters.vue?vue&type=style&index=0&id=370f3d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f3d32",
  null
  
)

export default component.exports